import {useNavigate, useSearchParams} from 'react-router-dom';
import PaymentReceipt from '../../../shopping-basket/cash-payment/PaymentReceipt';

enum PaymentStatus {
  PENDING = 1,
  SUCCESSFUL = 2,
  FAILED = 3,
}

const TransactionReport = ({
  fallbackRoute = '/home',
}: {
  fallbackRoute?: string;
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const status = searchParams.get('status') ?? '';
  const tracing_code = searchParams.get('tracing_code') ?? '';

  // this is a route that the user goes to when it is succeed w
  const onSuccessNavigate = () =>
    navigate(fallbackRoute, {
      state: {isPaymentSuccessful: true},
      replace: true,
    });

  return (
    <>
      {Number(status) === PaymentStatus.SUCCESSFUL && (
        <PaymentReceipt
          type="success"
          tracingCode={tracing_code}
          title="عملیات با موفقیت انجام شد"
          description={`پرداخت شما با شماره پیگیری ${tracing_code} با موفقیت انجام و درخواست مشاوره شما با موفقیت ثبت شد. مشاورین مزرعه طی ساعت‌های آینده با شما تماس خواهند گرفت.`}
          buttonText="تایید و ادامه"
          buttonOnClick={onSuccessNavigate}
          timer={5}
          onNavigateAfterTimer={onSuccessNavigate}
        />
      )}

      {Number(status) === PaymentStatus.FAILED && (
        <PaymentReceipt
          type="failed"
          tracingCode={tracing_code}
          title="عملیات ناموفق"
          description={`پرداخت شما با شماره پیگیری ${tracing_code} ناموفق بود. لطفا دوباره تلاش کنید. چنانچه طی این فرآیند مبلغی از حسابتان کم شده است طی 72 ساعت آینده به حسابتان برمی‌گردد.`}
          buttonText="بازگشت"
          buttonOnClick={() => navigate(fallbackRoute)}
          timer={5}
          onNavigateAfterTimer={() => navigate(fallbackRoute)}
        />
      )}
    </>
  );
};

export default TransactionReport;
